import { useField } from 'formik';
import { useMemo, useRef, useState } from 'react';
import { Choice } from '../Components/SelectItem/type/choice';

type Params = {
  name: string;
  choices: Choice[];
};

export function useViewModel(params: Params) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openToTop, setOpenToTop] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [field, meta, helpers] = useField(params.name);
  const activeChoice = useMemo(
    () => params.choices.find(choice => choice.value === field.value) || null,
    [field.value],
  );

  const closeSelectHandler = () => {
    setIsOpen(false);
    document.removeEventListener('click', closeSelectHandler);
  };

  const itemClickHandler = (choice: Choice) => {
    helpers.setValue(choice.value);
    setIsOpen(false);
  };

  const previewClickHandler = () =>
    setIsOpen(oldIsOpen => {
      const { top } = wrapperRef.current?.getBoundingClientRect() || { top: 0 };
      setOpenToTop(top > window.innerHeight / 2);

      if (!oldIsOpen) {
        setTimeout(() => document.addEventListener('click', closeSelectHandler), 100);
      }

      return !oldIsOpen;
    });

  return {
    isOpen,
    itemClickHandler,
    previewClickHandler,
    value: field.value,
    meta,
    activeChoice,
    wrapperRef,
    openToTop,
  };
}
